<script lang="ts" setup generic="T extends string | number">
const props = defineProps<{
  name: string;
  label: string;
  options: any;
  selected: T | undefined | null;
  available: T[];
  getOptionLabel: (value: T) => string | number;
  onSelect: (value: T) => void;
  onTrack?: (key: string, vehicle: any) => void;
  trackPrefix?: string;
  vehicle: any;
}>();

const isAvailable = (option: T) => props.available.includes(option);
const getStyle = (option: T) => {
  return {
    opacity: isAvailable(option) ? 1 : 0.4,
    cursor: isAvailable(option) ? 'pointer' : 'not-allowed',
    'pointer-events': isAvailable(option) ? 'auto' : 'none',
  };
};

const handleClick = (option: T, event: Event) => {
  if (!isAvailable(option)) {
    event.preventDefault();
    return;
  }

  props.onSelect(option);
  props.onTrack?.(
    `${props.trackPrefix ?? props.name}.${option}`,
    props.vehicle,
  );
};
</script>

<template>
  <div :class="`${name}-selector`">
    <span class="owvans-technical-data-wrapper__column-text wb-text-s">
      {{ label }}
    </span>
    <div role="radiogroup" class="owvans-technical-data-tag-group">
      <wb7-interactive-tag
        v-for="option in options"
        :key="`${name}-${option}-${selected}`"
        type="tertiary"
        variant="radio"
        :checked="option === selected"
        :data-test-id="`owvans-tech-data-${name}-desktop-${option}`"
        :style="getStyle(option)"
        :aria-disabled="!isAvailable(option)"
        :tabindex="isAvailable(option) ? 0 : -1"
        role="radio"
        @click="handleClick(option, $event)"
        @keydown.enter.prevent="handleClick(option, $event)"
        size="m"
      >
        {{ getOptionLabel(option) }}
      </wb7-interactive-tag>
    </div>
  </div>
</template>

<style scoped>
.owvans-technical-data-wrapper__column-text {
  color: var(--wb-grey-20);
  font-size: 1rem;
  font-weight: 700;
}
.owvans-technical-data-tag-group {
  margin-top: 8px;
  display: flex;
  gap: 12px;
}
</style>
